var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ShareValues = /** @class */ (function () {
    function ShareValues() {
        this.data = {
            authResult: undefined,
            selectedGrant: undefined,
            centralProfile: undefined,
            application: undefined
        };
    }
    ShareValues.getInstance = function () {
        if (!ShareValues.instance) {
            ShareValues.instance = new ShareValues();
        }
        return ShareValues.instance;
    };
    ShareValues.getData = function () {
        return ShareValues.getInstance().data;
    };
    ShareValues.updateInstance = function (state) {
        ShareValues.getInstance().data = __assign({}, state);
    };
    ShareValues.getAuthResultTokenAccess = function () {
        return ShareValues.getData().authResult
            ? ShareValues.getData().authResult.accessToken
            : null;
    };
    return ShareValues;
}());
export { ShareValues };
//# sourceMappingURL=ShareValues.js.map